<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <md-card ref="parentCard">
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>group</md-icon>
          </div>
          <h4 class="title">Parents</h4>
        </md-card-header>

          <!-- Export Button - Top Right -->
          <div class="export-button-container">
            <md-button 
              class="md-primary" 
              :disabled="isExporting || total === 0" 
              @click="exportAllData()"
            >
              <md-icon>cloud_download</md-icon>
              {{ isExporting ? 'Exporting...' : 'Export All' }}
            </md-button>
          </div>
        <md-card-content>

          <!-- FILTERS SECTION -->
          <div class="filters-container">
            <div class="md-layout md-gutter">
              <!-- Row 1 -->
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100">
                <md-field>
                  <md-datepicker v-model="filters.fromDate" placeholder="From Date" md-immediately>
                    <label>From Date</label>
                  </md-datepicker>
                </md-field>
              </div>

              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100">
                <md-field>
                  <md-datepicker v-model="filters.toDate" md-immediately>
                    <label>To Date</label>
                  </md-datepicker>
                </md-field>
              </div>

              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100">
                <md-field>
                  <label>Email</label>
                  <md-input type="text" v-model="filters.email"></md-input>
                </md-field>
              </div>

              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100">
                <md-field>
                  <label>Phone Number</label>
                  <md-input type="text" v-model="filters.phoneNumber"></md-input>
                </md-field>
              </div>

              <!-- Row 2 -->
              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100">
                <md-field>
                  <label>Device Purchase Status</label>
                  <md-select v-model="filters.devicePurchaseFilter">
                    <md-option value="">All</md-option>
                    <md-option value="Completed">Completed</md-option>
                    <md-option value="Incomplete">Incomplete</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100">
                <md-field>
                  <label>Tag</label>
                  <md-select v-model="filters.tagFilter">
                    <md-option value="">All</md-option>
                    <md-option v-for="t in availableTags" :key="t" :value="t">
                      {{ t }}
                    </md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100">
                <md-field>
                  <label>SMS/Call Permission</label>
                  <md-select v-model="filters.smsPhoneCallFilter">
                    <md-option value="">All</md-option>
                    <md-option value="true">Enabled</md-option>
                    <md-option value="false">Disabled</md-option>
                  </md-select>
                </md-field>
              </div>

              <div class="md-layout-item md-size-25 md-small-size-50 md-xsmall-size-100">
                <div class="checkbox-field">
                  <md-checkbox v-model="filters.delegatedAccessUser" class="md-primary">
                    Delegated Access User
                  </md-checkbox>
                </div>
              </div>

              <!-- Row 3 - Action Buttons -->
              <div class="md-layout-item md-size-100">
                <div class="action-buttons">
                  <md-button 
                    class="md-primary md-raised" 
                    :disabled="isLoading" 
                    @click="searchParents()"
                  >
                    <md-icon>search</md-icon> 
                    {{ isLoading ? 'Searching...' : 'Search' }}
                  </md-button>

                  <md-button 
                    class="md-default" 
                    @click="clearFilters()"
                    :disabled="isLoading"
                  >
                    <md-icon>clear</md-icon> Clear Filters
                  </md-button>
                </div>
              </div>
            </div>
          </div>

          <hr class="divider">

          <!-- Loading Indicator -->
          <div v-if="isLoading" class="loading-container">
            <md-progress-spinner md-mode="indeterminate" :md-diameter="40"></md-progress-spinner>
            <p class="loading-text">Loading parents...</p>
          </div>

          <!-- TABLE -->
          <div v-else>
            <md-table
              :value="tableData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
            >
              <md-table-toolbar>
                <div class="toolbar-container">
                  <md-field class="per-page-field">
                    <label for="pages">Per page</label>
                    <md-select v-model="pagination.perPage" name="pages" @md-selected="changePerPage">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                      >
                        {{ item }}
                      </md-option>
                    </md-select>
                  </md-field>

                  <div class="total-count">
                    <p class="card-category">
                      Total: <strong>{{ total }}</strong> parents
                    </p>
                  </div>
                </div>
              </md-table-toolbar>

              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <!-- Email -->
                <md-table-cell md-label="Email" md-sort-by="email" class="email-cell">
                  <a href="javascript:void(0)" @click="ByPassUserLogin(item.email)" class="email-link">
                    {{ item.email }}
                  </a>
                  <span v-if="item.country_code || item.phone_number">
                    <br>{{ item.country_code }} {{ item.phone_number }}
                  </span>
                  <span class="badge badge-info" v-if="item.delegatedAccessUser == true">
                    Delegated
                  </span>
                  <div v-if="item.name && item.name != item.email" class="sub-text">
                    {{ item.name }}
                  </div>
                </md-table-cell>

                <!-- Products -->
                <md-table-cell md-label="Products" class="products-cell">
                  <span v-if="getProductNames(item.cartData) !== '—'">
                    {{ getProductNames(item.cartData) }}
                  </span>
                  <span v-else class="empty-value">—</span>
                </md-table-cell>

                <!-- Device Purchase -->
                <md-table-cell md-label="Device Purchase" md-sort-by="devicePurchaseStatus" class="status-cell">
                  <span
                    :class="[
                      'badge',
                      item.devicePurchaseStatus === 'Completed' 
                        ? 'badge-success' 
                        : 'badge-danger'
                    ]"
                  >
                    {{ item.devicePurchaseStatus || 'Incomplete' }}
                  </span><br>
                  {{ HumanReadableDateFormat(item.updated_at) }}
                </md-table-cell>

                <!-- Review Request -->
                <md-table-cell md-label="Review Request" md-sort-by="reviewRequestSentCount" class="review-cell">
                  <div class="review-container">
                    <span class="badge badge-primary">{{ item.reviewRequestSentCount || 0 }}</span>
                    <button 
                      class="action-btn action-btn-sm" 
                      @click="$router.push({ 
                        path: '/kid/review-request', 
                        query: { email: item.email, delegatedAccessUser: item.delegatedAccessUser }
                      })"
                    >
                      Request
                    </button>
                  </div>
                </md-table-cell>

                <!-- Tag -->
                <md-table-cell md-label="Tag" class="tag-cell">
                  <div class="tag-box">
                    <input 
                      v-model="item.tag" 
                      placeholder="Add tag"
                      class="tag-input-with-btn"
                      @keyup.enter="updateTag(item)"
                    />
                    <button class="tag-btn-inside" @click="updateTag(item)" :disabled="!item.tag || item.tag.trim() === ''">
                      <md-icon style="font-size: 14px;">check</md-icon>
                    </button>
                  </div>
                </md-table-cell>

                <!-- SMS/Phone Call Permission -->
                <md-table-cell md-label="SMS/Call Access" class="checkbox-cell">
                  <div class="checkbox-container">
                    <md-checkbox 
                      v-model="item.canReadSMSAndPhoneCall" 
                      @change="updateSMSPhoneCallPermission(item)"
                      class="md-primary"
                    />
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>

            <!-- No Data Message -->
            <div v-if="tableData.length === 0 && !isLoading" class="no-data-container">
              <md-icon class="no-data-icon">inbox</md-icon>
              <p class="no-data-text">No parents found</p>
              <p class="no-data-subtext">Try adjusting your search filters</p>
            </div>
          </div>

        </md-card-content>

        <!-- Pagination Footer -->
        <md-card-actions md-alignment="space-between" v-if="!isLoading && tableData.length > 0">
          <div>
            <p class="card-category">
              Showing {{ from + 1 }} to {{ to }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
            @input="handlePageChange"
          ></pagination>
        </md-card-actions>

      </md-card>
    </div>
  </div>
</template>

<script>
import { Pagination } from "@/components";
import UsersDataService from "../../services/SuperAdmin/UsersDataService";

export default {
  components: { Pagination },

  computed: {
    to() {
      return Math.min(this.from + this.tableData.length, this.total);
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    }
  },

  data() {
    return {
      isLoading: false,
      isExporting: false,
      currentSort: "updated_at",
      currentSortOrder: "desc",

      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [10, 25, 50, 100],
      },

      tableData: [],
      total: 0,
      availableTags: [],

      // Consolidated filters object
      filters: {
        email: "",
        phoneNumber: "",
        fromDate: "",
        toDate: null,
        devicePurchaseFilter: "",
        tagFilter: "",
        smsPhoneCallFilter: "",
        delegatedAccessUser: false
      }
    };
  },

  methods: {
    scrollToTop() {
      this.$nextTick(() => {

        // Try all possible scroll containers
        const selectors = [
          '.main-panel',
          '.content',
          '.md-content',
          '.ps-container',
          '.md-app-scroller',
          '.md-scrollbar'
        ];

        let scrollContainer = null;

        for (const selector of selectors) {
          const el = document.querySelector(selector);

          if (el && el.scrollHeight > el.clientHeight) {
            scrollContainer = el;
            break;
          }
        }

        //console.log('FOUND SCROLL CONTAINER:', scrollContainer);

        if (scrollContainer) {
          scrollContainer.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        } else {
          window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      });
    },

    customSort(value) {
      // Return the value as-is; server-side sorting will be handled by watchers
      return value;
    },

    kidsParentsList() {
      this.isLoading = true;
      
      let data = {
        fromDate: this.filters.fromDate,
        toDate: this.filters.toDate,
        email: this.filters.email,
        phone_number: this.filters.phoneNumber,
        devicePurchaseStatus: this.filters.devicePurchaseFilter,
        tag: this.filters.tagFilter,
        canReadSMSAndPhoneCall: this.filters.smsPhoneCallFilter,
        delegatedAccessUser: this.filters.delegatedAccessUser ? 'true' : '',
        page: this.pagination.currentPage,
        limit: this.pagination.perPage,
        sortBy: this.currentSort,
        sortOrder: this.currentSortOrder
      };

      UsersDataService.kidsParentsList(data)
        .then((response) => {
          this.tableData = response.data.data || [];
          this.total = response.data.total || 0;
          this.availableTags = response.data.tags || [];
          this.isLoading = false;
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error fetching data");
          this.isLoading = false;
          this.tableData = [];
          this.total = 0;
        });
    },

    searchParents() {
      this.pagination.currentPage = 1;
      this.kidsParentsList();
    },

    handlePageChange(page) {
      this.pagination.currentPage = page;
      this.kidsParentsList();
      this.$nextTick(() => {
        this.scrollToTop();
      });
    },

    changePerPage() {
      this.pagination.currentPage = 1;
      this.scrollToTop();
      this.kidsParentsList();
    },

    clearFilters() {
      this.filters = {
        email: "",
        phoneNumber: "",
        fromDate: "",
        toDate: null,
        devicePurchaseFilter: "",
        tagFilter: "",
        smsPhoneCallFilter: "",
        delegatedAccessUser: false
      };
      this.pagination.currentPage = 1;
      this.kidsParentsList();
    },

    updateTag(item) {
      if (!item.tag || item.tag.trim() === "") {
        this.$toast.warning("Please enter a tag");
        return;
      }

      UsersDataService.updateParentTag({
        userId: item._id,
        tag: item.tag.trim()
      })
        .then(() => {
          this.$toast.success("Tag updated successfully");
          this.kidsParentsList();
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error updating tag");
        });
    },

    updateSMSPhoneCallPermission(item) {
      UsersDataService.updateCanReadSMSAndPhoneCall({
        userId: item._id,
        email: item.email,
        canReadSMSAndPhoneCall: item.canReadSMSAndPhoneCall
      })
        .then((response) => {
          this.$toast.success(response.data.respones_msg || "Permission updated successfully");
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error updating permission");
          item.canReadSMSAndPhoneCall = !item.canReadSMSAndPhoneCall;
        });
    },

    ByPassUserLogin(email) {
      UsersDataService.ByPassUserLogin({ email })
        .then((response) => {
          window.open(
            "https://parent.mywingio.com?token=" + response.data.data.token,
            "_blank"
          );
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Login failed");
        });
    },

    getProductNames(cartData) {
      if (!cartData || !Array.isArray(cartData)) return "—";
      return cartData
        .map((c) => c?.productDetail?.name || "Unknown Product")
        .join(", ");
    },

    exportAllData() {
      if (this.total === 0) {
        this.$toast.warning("No data to export");
        return;
      }

      this.isExporting = true;

      let exportFilters = {
        fromDate: this.filters.fromDate,
        toDate: this.filters.toDate,
        email: this.filters.email,
        phone_number: this.filters.phoneNumber,
        devicePurchaseStatus: this.filters.devicePurchaseFilter,
        tag: this.filters.tagFilter,
        canReadSMSAndPhoneCall: this.filters.smsPhoneCallFilter,
        delegatedAccessUser: this.filters.delegatedAccessUser ? 'true' : ''
      };

      UsersDataService.exportWingioParents(exportFilters)
        .then((response) => {
          const exportData = response.data.data || [];
          
          if (exportData.length === 0) {
            this.$toast.warning("No data to export");
            this.isExporting = false;
            return;
          }

          let csv = 'Email,Name,Referral Code,Phone,Kids Names,Device Purchase,Review Req Count,Tag,SMS/Call Access,Delegated Parent,Created On\n';
          
          exportData.forEach((data) => {
            const row = [
              data.email || '',
              data.name || '',
              data.referralCode || '',
              `${data.country_code || ''} ${data.phone_number || ''}`.trim(),
              data.kidsNames || '',
              data.devicePurchaseStatus || 'Incomplete',
              data.reviewRequestSentCount || 0,
              data.tag || '',
              data.canReadSMSAndPhoneCall ? 'Yes' : 'No',
              data.delegatedParentInfo || '',
              data.created_at || ''
            ];
            csv += row.map(field => `"${field}"`).join(',') + "\n";
          });

          const anchor = document.createElement('a');
          anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
          anchor.target = '_blank';
          anchor.download = `wingio-parents-${new Date().toISOString().split('T')[0]}.csv`;
          anchor.click();
          
          this.$toast.success(`Exported ${exportData.length} records successfully`);
          this.isExporting = false;
        })
        .catch((e) => {
          this.$toast.error(e.response?.data?.respones_msg || "Error exporting data");
          this.isExporting = false;
        });
    }
  },

  beforeMount() {
    this.kidsParentsList();
  },

  watch: {
    'filters.devicePurchaseFilter'() {
      this.pagination.currentPage = 1;
      this.kidsParentsList();
    },
    'filters.tagFilter'() {
      this.pagination.currentPage = 1;
      this.kidsParentsList();
    },
    'filters.smsPhoneCallFilter'() {
      this.pagination.currentPage = 1;
      this.kidsParentsList();
    },
    // Watch for sort changes
    currentSort() {
      this.pagination.currentPage = 1;
      this.scrollToTop();
      this.kidsParentsList();
    },
    currentSortOrder() {
      this.pagination.currentPage = 1;
      this.scrollToTop();
      this.kidsParentsList();
    }
  }
};
</script>

<style scoped>
/* Export Button Container - Top Right */
.export-button-container {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
}

/* Filters Container */
.filters-container {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  margin-top: 10px;
}

.checkbox-field {
  display: flex;
  align-items: center;
  height: 48px;
  padding-top: 16px;
}

.action-buttons {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  flex-wrap: wrap;
  margin-top: 10px;
}

.divider {
  margin: 20px 0;
  border: 0;
  border-top: 1px solid #e0e0e0;
}

/* Loading State */
.loading-container {
  text-align: center;
  padding: 60px 20px;
}

.loading-text {
  margin-top: 16px;
  color: #666;
  font-size: 14px;
}

/* Toolbar */
.toolbar-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;
}

.per-page-field {
  min-width: 120px;
  max-width: 150px;
  margin: 0;
}

.total-count {
  margin-left: auto;
}

.total-count .card-category {
  margin: 0;
  font-size: 14px;
  color: #666;
}

/* Table Cells */
::v-deep .md-table-cell {
  word-wrap: break-word;
  white-space: normal;
  vertical-align: middle;
  padding: 14px 12px;
  font-size: 13px;
}

.email-cell {
  min-width: 200px;
}

.phone-cell {
  min-width: 140px;
}

.products-cell {
  min-width: 150px;
}

.status-cell {
  min-width: 140px;
  text-align: center;
}

.review-cell {
  min-width: 150px;
}

.tag-cell {
  min-width: 170px;
}

.checkbox-cell {
  min-width: 120px;
  text-align: center;
}

.date-cell {
  min-width: 140px;
}

.email-link {
  color: #8e24aa;
  text-decoration: none;
  font-weight: 500;
  display: inline-block;
  margin-bottom: 4px;
}

.email-link:hover {
  text-decoration: underline;
}

.sub-text {
  font-size: 12px;
  color: #666;
  margin-top: 4px;
}

.empty-value {
  color: #999;
  font-style: italic;
}

/* Review Request Container */
.review-container {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-start;
}

/* Tag Box */
.tag-box {
  position: relative;
  width: 160px;
}

.tag-input-with-btn {
  width: 100%;
  height: 36px;
  padding: 6px 42px 6px 10px;
  font-size: 13px;
  border: 1px solid #ddd;
  border-radius: 4px;
  transition: all 0.3s;
}

.tag-input-with-btn:focus {
  outline: none;
  border-color: #8e24aa;
  box-shadow: 0 0 0 2px rgba(142, 36, 170, 0.1);
}

.tag-btn-inside {
  position: absolute;
  right: 4px;
  top: 50%;
  transform: translateY(-50%);
  height: 28px;
  width: 34px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #8e24aa;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.3s;
}

.tag-btn-inside:hover:not(:disabled) {
  background: #6a1b9a;
}

.tag-btn-inside:disabled {
  background: #ccc;
  cursor: not-allowed;
}

/* Checkbox Container */
.checkbox-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Action Button */
.action-btn {
  padding: 6px 14px;
  font-size: 12px;
  background: #8e24aa;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: 500;
}

.action-btn:hover {
  background: #6a1b9a;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

.action-btn-sm {
  padding: 5px 10px;
  font-size: 11px;
}

/* Badges */
.badge {
  display: inline-block;
  padding: 5px 10px;
  font-size: 11px;
  font-weight: 600;
  border-radius: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-success {
  background: #4caf50;
  color: white;
}

.badge-danger {
  background: #f44336;
  color: white;
}

.badge-info {
  background: #2196f3;
  color: white;
  /*margin-left: 6px;*/
  font-size: 10px;
}

.badge-primary {
  background: #8e24aa;
  color: white;
}

/* No Data State */
.no-data-container {
  text-align: center;
  padding: 60px 20px;
}

.no-data-icon {
  font-size: 64px !important;
  color: #ccc;
}

.no-data-text {
  margin-top: 16px;
  color: #666;
  font-size: 16px;
  font-weight: 500;
}

.no-data-subtext {
  margin-top: 8px;
  color: #999;
  font-size: 14px;
}

/* Card Actions */
.md-card .md-card-actions {
  border: 0;
  margin-left: 20px;
  margin-right: 20px;
  padding: 16px 0;
}

/* Card Content - Add relative positioning for absolute export button */
.md-card-content {
  position: relative;
}

/* Responsive */
@media (max-width: 768px) {
  .export-button-container {
    position: static;
    margin-bottom: 10px;
    text-align: right;
  }

  .filters-container {
    padding: 15px;
  }
  
  .action-buttons {
    justify-content: stretch;
  }
  
  .action-buttons .md-button {
    flex: 1;
    min-width: 0;
  }
  
  .toolbar-container {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .total-count {
    margin-left: 0;
  }
}
</style>